import type { Guide } from '../types';

/**
 * S-21.10-24 — szersze obejście blokad przez Team Leadera (BR-FTL-14; scenariusz e2e 9 — okno `dlg-powod` /
 * `dlg-ok`). Rekord (dane pod slajdy z 22.10.2026): DEMO/2026/10/B02 z wariantem DEMO 013 — auto poza
 * eksploatacją w TMS, z Blokadą po terminie i znaną ładownością zestawu 9 t przy 20 t ładunku. Okno „Obsadź mimo
 * blokady” otwiera dopiero odmowa obsadzenia — nagrywarka klika „Obsadź”, które serwer przy tych danych odrzuca
 * (sprawdza to), i niczego nie zapisuje.
 */
export const guide: Guide = {
  flagKey: 'assignOverrideWider',
  title: 'Obsadzenie mimo blokady: także ładowność i auto poza eksploatacją',
  whatItDoes:
    'Team Leader (planista główny) i administratorzy obsadzają mimo blokady nie tylko przy nieważnym uprawnieniu typu Blokada, ale też przy za małej znanej ładowności zestawu i przy aucie oznaczonym w TMS jako poza eksploatacją. Okno „Obsadź mimo blokady” wylicza wtedy wszystko, co blokuje, i wymaga powodu (co najmniej 10 znaków), a historia zmian zlecenia zapisuje, kto, dlaczego i który warunek pominął. Nieważnego zezwolenia na pracę kierowcy, auta niedostępnego w TMS i ADR „nie” nie obchodzi nikt.',
  audience: ['Team Leader (planista główny)', 'administrator'],
  presentationItems: ['S-21.10-24'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie z wariantem, którego obsadzenie blokuje przeszkoda (uprawnienie, ładowność, eksploatacja)',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'dlg-powod',
      mockupTestId: 'dlg-powod',
      title: 'Okno „Obsadź mimo blokady”',
      description:
        'Gdy obsadzenie wybranym wariantem blokują przeszkody, które wolno obejść, zamiast odmowy otwiera się okno z listą blokad — tu Blokada z uprawnień, za mała znana ładowność zestawu i auto poza eksploatacją — i polem powodu. Przeszkody nie do obejścia kończą się odmową z komunikatem, jak dotąd.',
      action:
        'Wybierz wariant w „Obsadź pojazdem” i kliknij „Obsadź” (albo „Obsadź…” w wierszu banku); w oknie wpisz powód i kliknij „Obsadź mimo blokady”.',
      recorder: {
        account: 'master',
        demo: { kind: 'order', number: 'DEMO/2026/10/B02' },
        actions: [
          { kind: 'select', label: 'Obsadź pojazdem', option: 'DEMO 013', prefix: true },
          { kind: 'clickRefused', name: 'Obsadź', requestPath: '/assign-car' },
        ],
      },
    },
  ],
};
